import React from 'react';
import LoadingButton from '../LoadingButton';

interface ExportButtonProps {
	onClick: () => void;
	color: 'primary' | 'inherit';
	variant?: 'contained' | 'outlined' | 'text';
	icon?: React.ReactNode;
	children: React.ReactNode;
	style?: React.CSSProperties;
	loading?: boolean;
}

const ExportButton: React.FC<ExportButtonProps> = ({ onClick, variant = 'contained', color, icon, children, style, loading }) => (
	<LoadingButton
		variant={variant}
		loading={loading}
		color={color}
		style={{
			minWidth: 140,
			padding: '7px 3rem',
			fontWeight: 500,
			borderWidth: 2,
			...style,
		}}
		onClick={onClick}
		endIcon={icon}
	>
		{children}
	</LoadingButton>
);

export default ExportButton;
